import $ from 'jquery';

'use strict';

const initGalleryFilter = () => {
  $('.filterable-gallery-section').each(function () {
    const $section = $(this);
    const $filters = $section.find('.filter-btn');
    const $items = $section.find('.gallery-item');

    $filters.on('click', function (e) {
      e.preventDefault();
      const $currentBtn = $(this);
      const targetFilter = $currentBtn.data('filter');
      $filters.removeClass('active');
      $currentBtn.addClass('active');
      if (targetFilter === 'all') {
        $items.removeClass('is-hidden');
      } else {
        $items.each(function () {
          const $item = $(this);
          if ($item.data('category') === targetFilter) {
            $item.removeClass('is-hidden');
          } else {
            $item.addClass('is-hidden');
          }
        });
      }
    });
  });
};
$(document).ready(function () {
  initGalleryFilter();
});
